import React from 'react'
import { Card, Input, Space, Tabs } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useRFQs } from '../hooks/useRFQs'
import { useRFQActions } from '../hooks/useRFQActions'
import { RFQsTable } from '../components/RFQsTable'
import { RFQDetailsDrawer } from '../components/RFQDetailsDrawer'

export const RFQsScreen: React.FC = () => {
    const { rfqs, searchText, setSearchText, activeTab, setActiveTab } = useRFQs()
    const {
        selectedRFQ,
        isDetailDrawerOpen,
        handleViewDetails,
        handleAcceptBid,
        handleRejectBid,
        closeDrawer
    } = useRFQActions()

    const tabItems = [
        { key: 'all', label: 'All RFQs', children: null },
        { key: 'open', label: 'Open', children: null },
        { key: 'bidding', label: 'Bidding', children: null },
        { key: 'closed', label: 'Closed', children: null },
    ]

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search RFQs..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                </Space>

                <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />

                <RFQsTable
                    rfqs={rfqs}
                    onRowClick={handleViewDetails}
                />
            </Card>

            <RFQDetailsDrawer
                rfq={selectedRFQ}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onAcceptBid={handleAcceptBid}
                onRejectBid={handleRejectBid}
            />
        </Space>
    )
}
